import React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    categoryText: {
      // fontFamily:"Black Han Sans"
      fontFamily: "Noto Sans KR",
      fontSize: 64,
      color: "black",
      fontWeight: 900,
      letterSpacing: -4,
      paddingBottom: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 32,
      },
    },

    describeText: {
      color: "black",
      fontWeight: 500,
      //   paddingLeft: 24,
      marginTop: -2,
      fontFamily: "Noto Sans KR",
      lineHeight: 1.7,
      fontSize: 20,
    },
    subCategory: {
      fontFamily: "Noto Sans KR",
      fontSize: 40,
      color: "black",
      fontWeight: 500,
      //   paddingLeft:6
      letterSpacing: -1,
    },
    infoDiv: {
      display: "flex",
      marginBottom: "8%",
      [theme.breakpoints.down("xs")]: {
        display: "block",
        marginBottom: "8%",
      },
    },
  })
);

interface InfoPageProps {
  // history: History;
  categoryInfo: React.ReactNode | string | null;
  title: React.ReactNode | string | null;
  describe: React.ReactNode | string | null;
}

function InfoPageTemplate({ title, describe, categoryInfo }: InfoPageProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div>
      <Grid xs={12} item>
        <div
          style={{
            fontFamily: "Noto Sans KR",
            fontSize: 24,
            color: "#9e7d48",
            fontWeight: 700,
            //   paddingLeft:6
            letterSpacing: -1,
            paddingBottom: 24,
          }}
        >
          {categoryInfo}
        </div>
      </Grid>
      <Grid xs={12} item component="div" className={classes.infoDiv} style={{}}>
        <Grid
          // container
          // spacing={0}
          // alignItems="center"
          // justify="center"
          item
          xs={!matches ? 5 : 12}
        >
          <div className={classes.categoryText}>{title}</div>
          {/* <div className={classes.subCategory}>미래의 나에게 말 걸기</div> */}
        </Grid>
        <Grid xs={!matches ? 7 : 12} item>
          <Grid className={classes.describeText}>{describe}</Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default InfoPageTemplate;
